import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input, NgModule, OnInit } from '@angular/core';
import { Cms} from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '../../button/button.module';
import { CircularProgressModule } from '../../circular-progress/circular-progress.module';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { StarsScoreModule } from '../../stars-score/stars-score.module';
import { EuroNCAPSafetyRatingsComponent } from './euro-ncap-safety-ratings.component';
import { checkIfExternalImage, resolveMediaUrl } from '../../utils/helpers/media-helpers';
import { UtilsModule } from '../../utils/utils.module';
import { ENVIRONMENT, Environment } from '../../environment/environment';

interface ModelData {
    stars: number;
    adultOccupantRating?: number;
    childOccupantRating?: number;
    pedestrianRating?: number;
    safetyAssistRating?: number;
}

@Component({
    selector: 'app-euro-ncap-score-spot',
    template: `
        <ng-container *ngIf="modelData">
            <app-rich-text [html]="data.textContent"></app-rich-text>
            <app-stars-score [score]="modelData?.stars ?? 0"></app-stars-score>
            <ng-container *ngIf="modelData">
                <app-euro-ncap-safety-ratings
                    [adultOccupantRating]="modelData?.adultOccupantRating ?? 0"
                    [childOccupantRating]="modelData?.childOccupantRating ?? 0"
                    [pedestrianRating]="modelData?.pedestrianRating ?? 0"
                    [safetyAssistRating]="modelData?.safetyAssistRating ?? 0"
                ></app-euro-ncap-safety-ratings>
            </ng-container>
           <app-button *ngIf="data.euroNCAPReportLink" [link]="link"  [title]="data.reportLinkText" buttonClass="button--primary button--themed"></app-button>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
class EuroNCAPScoreSpotComponent implements OnInit {

    @HostBinding('class') class = 'euro-ncap-score-spot';
    @Input() data: Cms.EuroNCAPSpot;

    link: Cms.Link | undefined;
    modelData: ModelData;

    constructor(@Inject(ENVIRONMENT) private environment: Environment) {
    }

    ngOnInit(): void {

        const model = this.data.vehicleModel;
        const media = this.data.euroNCAPReportLink;

        if (model) {
            this.modelData = {
                stars: Number(model?.starsRating),
                adultOccupantRating: model?.adultOccupantRating,
                childOccupantRating: model?.childOccupantRating,
                pedestrianRating: model?.pedestrianRating,
                safetyAssistRating: model?.safetyAssistRating,
            };
        } else {
            console.warn('[BN error: no data for EuroNCAP spot]');
        }

        if (media) {
            this.link = {
                ...this.data.euroNCAPReportLink,
                url: checkIfExternalImage(media.url)? media.url: resolveMediaUrl(this.data.euroNCAPReportLink.url,this.environment),
                isExternal:true,
                target:'_blank',
             };
        }
    }

}

@NgModule({
    declarations: [EuroNCAPScoreSpotComponent, EuroNCAPSafetyRatingsComponent],
    imports: [CommonModule, RichTextModule, StarsScoreModule, ButtonModule, TranslateModule.forChild(), CircularProgressModule, UtilsModule],
})
class ArticlesSpotModule {}

export const LazySpotComponent = EuroNCAPScoreSpotComponent;
